import { LoadingIcon } from 'morpheus-ui';
import { Fragment } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';

interface IEssaySendFooter {
  disabled: boolean;
  onSend: (action: string) => void;
  onCancel: () => void;
  isLoading: boolean;
  onBack?: () => void;
  showBackButton?: boolean;
  embedded?: boolean;
}

export default function EssaySendFooter({
  disabled = false,
  onCancel,
  onSend,
  isLoading,
  onBack,
  showBackButton = true,
  embedded = false,
}: IEssaySendFooter) {
  return (
    <div
      className={`bottom-0 left-0 flex w-full flex-row gap-xl py-4 ${
        embedded
          ? 'relative m-auto max-w-[750px]'
          : 'fixed bg-color-lightest px-8'
      }`}
    >
      <Button
        size='regular'
        variant='outlined'
        onClick={() => (showBackButton && onBack ? onBack() : onCancel())}
      >
        {showBackButton ? (
          'Voltar'
        ) : (
          <Typography className='text-feedback-color-error-pure'>
            Cancelar envio
          </Typography>
        )}
      </Button>
      <div className='flex-1'>
        <Button
          size='regular'
          variant='contained'
          disabled={disabled}
          full
          onClick={() => onSend('send')}
        >
          {isLoading ? (
            <div className='flex w-full items-center justify-center'>
              <LoadingIcon className='stroke-current h-6 animate-spin fill-none text-center' />
            </div>
          ) : (
            <Fragment>
              <Icon
                Icon='send'
                type='material'
                className='xs:hidden lg:block'
              />
              Enviar redação
            </Fragment>
          )}
        </Button>
      </div>
    </div>
  );
}
